import React from 'react';
import { componentByTypename } from '@/ui/utils/componentByTypename';
import OptimizedImage from '@/ui/components/shared/OptimizedImage';
import { RichTextRenderer } from '@/ui/components/tileRenderers/RichTextRenderer';
import ButtonLink from '@/ui/components/shared/ButtonLink';
import { twJoin } from 'tailwind-merge';
import { ProductBentoBoxTile } from './types/ProductBentoBoxTile';

export default function ProductBentoBox({
  tile,
  trackingPrefix,
}: Readonly<{
  tile: ProductBentoBoxTile;
  trackingPrefix?: string;
}>) {
  const productName = componentByTypename(tile.product.items?.[0], 'Product')?.name;
  const shortDescription = tile['short-description'];
  const minHeight = tile['min-height']?.options?.[0]?.value;

  let minHeightClasses;
  switch (minHeight) {
    case 'md':
      minHeightClasses = 'min-h-[200px] sm:min-h-[300px]';
      break;
    case 'lg':
      minHeightClasses = 'min-h-[300px] sm:min-h-[450px]';
      break;
    case 'xl':
      minHeightClasses = 'min-h-[400px] sm:min-h-[600px]';
      break;
    default:
      minHeightClasses = '';
      break;
  }

  return (
    <div className={twJoin('h-full bg-neutral-5 sm:flex', minHeightClasses)}>
      <OptimizedImage
        imageComponent={tile.image}
        sizes="(max-width: 768px) 50vw, 350px"
        width={200}
        height={200}
        className="ml-5 mt-auto h-auto object-contain sm:ml-0 sm:w-1/2"
      />
      <div className="m-5 flex flex-col justify-center sm:ml-0 sm:w-1/2">
        <h3 className="mb-2 text-xl font-bold sm:text-2xl lg:text-3xl">{productName}</h3>
        <RichTextRenderer blocks={shortDescription} className="mb-3 lg:text-lg" />
        <ButtonLink
          ctaComponent={tile.cta}
          className="mt-3 sm:mt-5 md:mt-10"
          trackingPrefix={trackingPrefix}
        />
      </div>
    </div>
  );
}
